// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f9a9bf00","453":"1fcdf2e5","455":"3eaffc50","977":"dea9b65b"}[chunkId] + ".chunk.js";
};